import { State } from "core";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import electronService from "../services/ElectronService";
const useDebug = () => {
  const { config } = useSelector((state: State) => state.globalState);
  useEffect(() => {
    electronService.sendDebug(
      electronService.debugFromCommandLine ||
        config?.userConf?.levelLogClient === "debug" ||
        config?.userConf?.levelLogClient === "trace",
    );
  }, [config]);
};
export default useDebug;
